import './index.css';
import { make } from '../../../utils';
import { toggleModal } from '../../../modal';

import { IconAddBorder } from '@codexteam/icons';

export default class DocumentSectionBlock {

  static get isReadOnlySupported() {
	return true;
  }
  static get toolbox() {
	return {
	  icon: IconAddBorder,
	  title: 'Document Section',
	};
  }

  static get tunes() {
	return [];
  }
  static get sanitize() {
	return {
	  documentSectionId: {},
	  customFieldIds: []
	};
  }

  constructor({ data, api, readOnly, config }) {
	this.api = api;
	this.readOnly = readOnly;
	this.config = config;
	this.modal = document.querySelector('#documentSectionsSelection-modal');

	this.nodes = {
	  wrapper: null,
	};

	this._data = {};
	this.data = data;
  }

  get CSS() {
	return {
	  baseClass: this.api.styles.block,
	  wrapper: 'document-section-block',
	};
  };

  render() {
	let wrapper = make('div', [this.CSS.baseClass, this.CSS.wrapper]);
	this.nodes.wrapper = wrapper;

	if (this.data.documentSectionId) {
	  this.fetchDocumentSection(this.data.documentSectionId)
		.then(documentSection => {
		  this.data = {
			documentSectionId: documentSection.id,
			customFieldIds: documentSection.customFieldIds
		  }
		  this.buildEditor(documentSection);
		});
	  return wrapper;
	}

	const handleDocumentSelection = (e) => {
	  if (e.detail.status !== 'SELECTED') {
		console.log('Selezione Cancellata');
		return;
	  }

	  this.fetchDocumentSection(e.detail.documentSectionId)
		.then(documentSection => {
		  this.data = {
			documentSectionId: documentSection.id
		  }
		  this.buildEditor(documentSection);
		});
	}

	document.addEventListener('documentsectionselected', handleDocumentSelection,
	  { once: true });

	toggleModal(this.modal);

	return wrapper;
  }

  fetchDocumentSection(documentSectionId) {
	return fetch(`/Templates/DocumentSections/Ajax/?handler=DocumentSectionById&id=${documentSectionId}`)
	  .then(response => {
		if (!response.ok)
		  throw new Error(response);
		return response.json()
	  }).then(json => {
		return json;
	  })
  }  

  buildEditor(documentSection) {
	this.nodes.wrapper.setAttribute('section-name', documentSection.name);
	if (documentSection.replacementCustomField !== null) {
	  this.nodes.wrapper.setAttribute('section-replacement', documentSection.replacementCustomField.name);
	}

	let tools = {
	  ...this.config.tools,
	  documentsection: {
		class: DocumentSectionBlock,
		shortcut: 'CMD+ALT+S',
		config: {
		  editorJs: this.config.editorJs,
		  tools: this.config.tools
		},
		tunes: []
	  },

	};

	let editorjs_instance = new this.config.editorJs({
	  holder: this.nodes.wrapper,
	  tools: tools,
	  tunes: ['alignment'],
	  readOnly: true,
	  minHeight: 0,
	  sanitize: {
		span: {
		  id: true,
		  contenteditable: true,
		  class: true
		}
	  },
	});

	let blocks = JSON.parse(documentSection.documentData);
	editorjs_instance.isReady.then(() => {
	  editorjs_instance.blocks.render({
		blocks: blocks
	  });
	})
  }

  validate() {
	return true;
  }

  save() {
	return this.data;
  }

  renderSettings() {
	return {}
  };

  get data() {
	return this._data;
  }
  set data(data) {
	this._data = Object.assign({}, this.data, data);
  }

}